export default {
  "filters": {
    "by_quarter": "По кварталам",
    "growing": "Нарастающий",
    "all_regions": "Все регионы",
    "all_cities": "Все города",
    "by_region": "По регионам / Республиканский уровень",
    "by_regions": "По регионам",
    "by_employees": "По сотрудникам",
    "search": "Поиск",
    "by_region_count": "Количество по регионам",
    "by_founders": "По учредителям",
    "by_activity": "По видам деятельности",
    "by_status": "Выберите статус",
    "sum": "Суммовой",
    "number": "Численный",
  },
  'st_active': 'На практике',
  'st_new': 'Новый',
  'st_removed': 'Выпущенный',
  "year_2017": "2017",
  "year_2018": "2018",
  "year_2019": "2019",
  "year_2020": "2020",
  "year_2021": "2021",
  "year_2022": "2022",
  "year_2023": "2023",
  "year_2024": "2024",
  "year_2025": "2025",
  "year_2026": "2026",
  "header": {
    "title": "Единая платформа экономических показателей резидентов ИТ-парка",
    "search": "Поиск ..."
  },
  "permission": {
    "message": "У вас нет доступа к этой панели!",
    "login": "Перейти на страницу входа"
  },
  "periods": {
    "all": "Период (весь период)",
    "all2": "весь период",
    "q1": "1 квартал",
    "q2": "2 квартал",
    "q3": "3 квартал",
    "q4": "4 квартал",
    "half": "Первое полугодие",
    "half2": "Второе полугодие",
    "half2-5": "9 месяцев",
  },
  "dashboard": {
    "number_of_residents": "Количество резидентов",
    "percent": "Процент",
    "number_of_employees": "Количество сотрудников",
    "total_income": "Общий доход",
    "total_income_mlrd": "Общий доход (млрд сумов)",
    "export_volume_usd": "Объем экспорта",
    "export_volume_usd_mlrd": "Объем экспорта (млн долл. США)",
    "general_indicators": "Общие показатели",
    "report_indicators": "Показатели отчета",
    "analytical_indicators": "Аналитические индикаторы",
    "audit_report_submission": "Представление аудиторского отчета",
    "audit_not_submitted": "Те, кто не представил аудиторский отчет",
    "tab_basic": "Общие показатели",
    "tab_report": "Показатели отчета",
    "tab_analytics": "Аналитические индикаторы",
    "in_detail": "подробно",
    "collections": "Агрегация",
    "quarterly_report_submission": "Представление ежеквартального отчета",
    "deduction_payment_info": "Разделение",
    "active_but_no_report": "На практике они не подавали отчеты как резиденты",
    "those_who_were_deprived_of_residency_during_this_period": "Список резидентов на текущий период",
    "number_of_deregistered_residents": "Количество снятых с регистрации жителей",
    "deduction_payment_info_description": "Информация о плате за увольнение",
    "must_submit_resident": "В процессе рассмотрения",
    "given": "Ведущие",
    "un_given": "Те, кто не представил",
    "returned_for_revision": "Возвращено для редактирования",
    "submitted": "Представлено",
    "debt_count": "Количество задолженностей",
    "not_submitted": "Не представлено",
    "more_details": "подробно",
    "virtual_office": "Виртуальный офис",
    "large_companies": "Крупные предприятия",
    "count_companies": "Количество компаний",
    "download_general_info": "Выгрузить все данные по «Общему показателю» в Excel",
    "virtual_office_contracts": "Резиденты с контрактом на виртуальный офис",
    "large_turnover_info": "Информация о резидентах с высокой текучестью кадров",
    "active": "На практике",
    "revoked": "Выпущенный",
    "main_comparison": "Сравнение",
    "export_comparison": "Сравнение",
    "by_countries": "В разрезе штатов",
    "main_indicator_comparison": "Сравнение основных показателей с соответствующим периодом",
    "export_vs_residence": "Соотношение объема экспорта к периоду проживания",
    "export_share_by_countries": "Доля экспорта по странам",
    "it_visa": "IT VISA",
    "export": "Экспорт",
    "foreign_capital_residents": "Резиденты с участием иностранного капитала",
    "foreign_capital_residents_organizations": "Резиденты с участием иностранного капитала",
    "it_visa_info": "Информация о IT VISA",
    "export_by_activity": "Объем экспорта в разрезе видов деятельности",
    "foreign_organizations": "Иностранные организации",
    "download_report_info": "Загрузите всю информацию по «Показателям отчета» в Excel",
    "it_park_rights": "IT Park Uzbekistan. Все права защищены 2019-2024",
    "residents_list": "Список резидентов",
    "active_residents_count": "Количество действующих резидентов",
    "is_active_residents_count": "Количество снятых с регистрации резидентов",
    "employee_count": "Количество сотрудников",
    "exporters": "Экспортеры",
    "resident_info": "Информация о резидентах",
    "employee_info": "О численности сотрудников",
    "service_exporters_info": "Информация о поставщиках экспортных услуг",
    "wage_amount": "Размер заработной платы",
    "total_count": "Число",
    "total_countries": "Количество стран"
  },
  "navigation": {
    "home": "Главная",
    "reminders": "Примечания",
    "reports": "Отчеты",
    "graphical_view": "В графическом виде",
    "general": "Общий",
    "residents": "Резиденты",
    "employees": "Сотрудники",
    "exporters": "Экспортеры",
    "income": "Доход",
    "table_view": "В табличном виде",
    "extended_info": "Расширенная информация",
    by_countries: "Экономическая информация по странам",
    "administrator": "Администратор"
  },
  "finance": {
    "total_income": "Общий доход",
    "search": "Поиск",
    "by_activity": "По видам деятельности",
    "by_region_amount": "Сумма по регионам",
    "by_activity_types": "По типам деятельности",
    "active_13_5_trillion": "Действующие 13,5 трлн сумов",
    "total_amount": "Общая сумма дохода",
    "above_100b_soum": "Общий доход более 100 млрд сумов",
    "between_50b_100b_soum": "Общий доход от 50 до 100 млрд сумов",
    "between_1b_50b_soum": "Общий доход от 1 до 50 млрд сумов",
    "below_1b_soum": "Общий доход до 1 млрд сумов"
  },
  "filters_periods": {
    "select_period": "Выберите период для сравнения:",
    "yearly_quarterly": "Ежегодно (ежеквартально)",
    "all": "Все",
    "partial": "Частично",
    "income": "Доход",
    "employee_count": "Количество сотрудников",
    "export_amount": "Сумма экспорта",
    "resident_count": "Количество резидентов"
  },
  "advanced_filters": {
    "select_period": "Выберите период для сравнения:",
    "yearly_quarterly": "Ежегодно (ежеквартально)",
    "all": "Все",
    "partial": "Частично",
    "incomes": "Доход",
    "employee_count": "Количество сотрудников",
    "export_amount": "Сумма экспорта",
    "residents_count": "Количество резидентов",
    "employees_salary": "Размер заработной платы",
    "incomes_10": "Оборот более 10 млрд",
    "export_50": "Доля экспорта более 50%",
    "foreign_founder_residents": "Количество резидентов с иностранным учредителем",
    "developers": "Количество программистов",
    "incomes_100": "Оборот более 100 млрд",
    "export_100": "Экспорт 100% числа",
    "new_residents": "Количество новых резидентов",
    "foreign_employees": "Иностранные сотрудники",
    "virtual_office_contracts": "Количество подписавших соглашение о виртуальном офисе",
    "out_residents": "Количество снятых с регистрации",
    "clear": "Очистить",
    "generate_data": "Формирование данных",
    "employees": "Ходимлар",
  },
  "deduction": "Разделение",
  "charged": "Рассчитано",
  "paid": "Оплачено",
  "total_employees": "Всего: 7 000 сотрудников, 10 компаний",
  "total_employee": "Всего сотрудников",
  "from_this": "из них",
  "serial_number": "№",
  "organization_tin": "ИНН",
  "organization_name": "Название организации",
  "region": "Регион",
  "city": "Город",
  "founder_country": "Страна учредителя",
  "registration_date": "Дата регистрации",
  "resident_status": "Статус резидента",
  "organization_type": "Тип организации",
  "export_share": "Доля экспорта",
  "admin_staff": "Административный персонал",
  "core_staff": "Ключевой персонал",
  "developers": "Программисты",
  "it_service_providers": "Поставщики информационных услуг",
  "teachers": "Учителя",
  "employee_count": "Количество сотрудников",
  "mhtf": "MXTF",
  "period": "Период",
  "chart_view": "Графический вид",
  "table_view": "Таблица",
  "export_direction": "Направление экспорта",
  "export_by_services": "Экспорт в секторе услуг",
  "eu_uk": "ЕС и Великобритания",
  "cis_apac": "СНГ и АТР",
  "total_export": "Общий экспорт",
  "north_america": "Северная Америка",
  "mena": "Ближний Восток и Северная Африка",
  "founders_export_share": "Доля экспорта по учредителям",
  "residents_period": "Период резидентства",
  "up_to_year": "до года",
  "year": "год",
  "search": "Поиск",
  "employees": "Сотрудники",
  "home": "Главная",
  "reminders": "Напоминания",
  "new": "Новый",
  "bpo": "BPO",
  "issued": "Выдан",
  "general": "Общий",
  "residents": "Резиденты",
  "exporters": "Экспортеры",
  "export": "Экспорт",
  "total_income": "Общий доход",
  "percentage_10": "10%",
  "percentage_30": "30%",
  "income_300m": "300 млн",
  "table_view_detailed": "Таблица с деталями",
  "detailed_info": "Подробная информация",
  "admin": "Администратор",
  "currency_trillion_soum": "трлн сумов",
  "currency_million": "млн",
  "regions_view": "По регионам / Республиканский уровень",
  "residents_view": "По резидентам",
  "region_based": "По регионам",
  "activity_based": "По видам деятельности",
  "founders_based": "По учредителям",
  "it_park": "ИТ Парк",
  "software_dev": "Разработка ПО",
  "usa": "США",
  "russia": "Россия",
  "samarkand": "Самарканд",
  "it_education": "ИТ-образование",
  "poland": "Польша",
  "top_5": "ТОП-5",
  "top_5_regions": "ТОП-5 регионов",
  "top_5_industry": "ТОП-5 Индустрия",
  "top_5_country": "ТОП-5 Страна",
  "toshkent_region": "Ташкентская область",
  "industry": "Индустрия",
  "vro": "ВРО",
  "country": "Страна",
  "germany": "Германия",
  "china": "Китай",
  "reports": "Отчеты",
  "bukhara": "Бухара",
  "support": "Поддержка",
  "graphical_view": "Графический вид",
  "fergana": "Фергана",
  "license_sales": "Продажа лицензий",
  "top_5_growth": "ТОП-5 по росту",
  "andijan": "Андижан",
  "tashkent": "Ташкент",
  "administrative_staff": "Административный персонал",
  "living_status": "По устойчивости",
  "registered": "Зарегистрировано",
  "revoked_residents": "Исключенные резиденты",
  "login_cabinet": "Вход в кабинет",
  "user_not_found": "Пользователь не найден",
  "no_such_user": "Такого пользователя нет.",
  "check_data": "Проверьте введенные данные и повторите попытку.",
  "return_to_login": "вернуться к входу",
  "oneid_description": "Единая система идентификации (OneID) предназначена для простого и безопасного доступа пользователей к различным информационным системам электронного правительства и государственных органов.",
  "platform_title": "Единая платформа экономических показателей резидентов ИТ-парка",
  "my_account": "Мой счет",
  "one_year": "1 год",
  "quarter": "квартал",
  "foreign_citizens_residents": "Иностранные граждане являются работающими резидентами",
  "annually": "Ежегодно",
  "quarterly": "Ежеквартально",
  "total_area": "Площадь (общая)",
  "qr": "QR",
  "andijan_region": "Андижанская область",
  "karakalpakstan": "Республика Каракалпакстан",
  "jizzakh_region": "Джизакская область",
  "kashkadarya_region": "Кашкадарьинская область",
  "navoi_region": "Навоийская область",
  "namangan_region": "Наманганская область",
  "samarkand_region": "Самаркандская область",
  "surkhandarya_region": "Сурхандарьинская область",
  "syrdarya_region": "Сырдарьинская область",
  "tashkent_region": "Ташкентская область",
  "fergana_region": "Ферганская область",
  "khorezm_region": "Хорезмская область",
  "tashkent_city": "город Ташкент",
  "billion_soum": "млрд сум",
  "other_income": "Прочие доходы",
  "it_services": "ИТ-услуги",
  "game_dev_creative": "Игровая разработка и креатив",
  "software_products": "Программные продукты",
  "turnover_10m_usd": "Объем экспорта более 10 миллионов долларов",
  "turnover_1m_10m_usd": "Объем экспорта от 1 млн до 10 млн за доллар",
  "turnover_100k_1m_usd": "Объем экспорта от 100 тыс. до 1 млн за доллар",
  "turnover_below_100k_usd": "Объем экспорта до 100 тыс. долларов",
  "export_countries": "В разделе стран-экспортеров",
  "top_5_countries": "ТОП-5 стран",
  "select_format": "Выберите формат",
  "save": "Сохранить",
  "operation_date": "Дата операции",
  "operation_content": "Содержание операции",
  "payment_date": "Дата платежа",
  "report_turnover": "Оборот в отчете",
  "calculated_payment": "Рассчитано на оплату",
  "debt": "Задолженность",
  "company_name": "Название компании",
  "company_number": "Номер компании",
  "added_period": "Добавлено в этот период",
  "close": "закрыт",
  "Работники, участвующие в основной (производственной)": "Работники, участвующие в основной (производственной)",
  "Сотрудники оказывающие информационные услуги": "Сотрудники оказывающие информационные услуги",

  "Вход в кабинет": "Вход в кабинет",
  "Пользователь не найден": "Пользователь не найден",
  "Такого пользователя нет.": "Такого пользователя нет.",
  "Проверьте введенные данные и повторите попытку.": "Проверьте введенные данные и повторите попытку.",
  "вернуться к входу": "вернуться к входу",
  "Единая система идентификации (OneID) предназначена для простого и безопасного доступа пользователей к различным информационным системам электронного правительства и государственных органов.": "Единая система идентификации (OneID) предназначена для простого и безопасного доступа пользователей к различным информационным системам электронного правительства и государственных органов.",

  "Единая платформа экономических показателей резидентов ИТ-парка": "Единая платформа экономических показателей резидентов ИТ-парка",
  "поиск": "поиск",
  "Мой счет": "Мой счет",
  "1 год": "1 год",
  "Иностранные граждане являются работающими резидентами": "Иностранные граждане являются работающими резидентами",
  "Ежегодно": "Ежегодно",
  "Ежеквартальный": "Ежеквартальный",
  "Площадь (общая)": "Площадь (общая)",
  "Общий": "Общий",
  "QR": "QR",
  "Андижанская область": "Андижанская область",
  "Республика Каракалпакстан\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t": "Республика Каракалпакстан\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t",
  "Бухарская область": "Бухарская область",
  "Джизакская область": "Джизакская область",
  "Кашкадарьинская область": "Кашкадарьинская область",
  "Навоийская область": "Навоийская область",
  "Наманганская область": "Наманганская область",
  "Самаркандская область": "Самаркандская область",
  "Сурхандарьинская область": "Сурхандарьинская область",
  "Сырдарьинская область": "Сырдарьинская область",
  "Ташкентская область": "Ташкентская область",
  "Ферганская область": "Ферганская область",
  "Хорезмская область": "Хорезмская область",
  "город Ташкент": "город Ташкент",
  "млрд сум": "млрд сум",
  "Количество жителей": "Количество жителей",
  "Количество сотрудников": "Количество сотрудников",
  "Общий доход\r\n(млрд сумов)": "Общий доход\r\n(млрд сумов)",
  "Прочие доходы": "Прочие доходы",
  "Объем экспорта,\r\nмлн долл. США": "Объем экспорта,\r\nмлн долл. США",
  "Объем экспорта": "Объем экспорта",
  "Общие показатели": "Общие показатели",
  "Показатели отчета": "Показатели отчета",
  "Аналитические индикаторы": "Аналитические индикаторы",
  "Информация о резидентах": "Информация о резидентах",
  "На практике": "На практике",
  "Выпущенный": "Выпущенный",
  "О численности сотрудников": "О численности сотрудников",
  "Размер заработной платы": "Размер заработной платы",
  "Экспортеры": "Экспортеры",
  "Информация о поставщиках экспортных услуг": "Информация о поставщиках экспортных услуг",
  "Число": "Всего",
  "Информация о резидентах с высоким оборотом": "Информация о резидентах с высоким оборотом",
  "Количество стран": "Количество стран",
  "IT Park Uzbekistan. Все права защищены 2019-2024": "IT Park Uzbekistan. Все права защищены 2019-2024",
  "Представление аудиторского отчета": "Представление аудиторского отчета",
  "Те, кто не представил аудиторский отчет": "Те, кто не представил аудиторский отчет",
  "Брошенный": "Брошенный",
  "Не представлено": "Не представлено",
  "подробно": "подробно",
  "Представление ежеквартального отчета": "Представление ежеквартального отчета",
  "На практике они не подавали отчеты как резиденты": "На практике они не подавали отчеты как резиденты",
  "Информация о плате за увольнение": "Информация о плате за увольнение",
  "Виртуальный офис": "Виртуальный офис",
  "Резиденты с контрактом на виртуальный офис": "Резиденты с контрактом на виртуальный офис",
  "Крупные предприятия": "Крупные предприятия",
  "Информация о резидентах с высокой текучестью кадров": "Информация о резидентах с высокой текучестью кадров",
  "Выгрузить все данные по «Общему показателю» в Excel": "Выгрузить все данные по «Общему показателю» в Excel",
  "Ежеквартальный отчет": "Ежеквартальный отчет",
  "Агрегация": "Агрегация",
  "Период (весь период)": "Период (весь период)",
  "Информация (по возрастанию)": "Информация (по возрастанию)",
  "Имя за именем": "Имя за именем",
  "№": "№",
  "Районы": "Районы",
  "Сообщаемые жители": "В процессе рассмотрения",
  "Ведущие": "Ведущие",
  "Возвращено для редактирования": "Возвращено для редактирования",
  "Те, кто не представил": "Те, кто не представил",
  "В процессе приёма": "В процессе приёма",
  "Всего по регионам": "Всего по регионам",
  "Скачать": "Скачать",
  "Выберите формат": "Выберите формат",
  "Сохранять": "Сохранять",
  "Аудиторский отчет": "Аудиторский отчет",
  "Сравнение": "Сравнение",
  "Сравнение основных показателей с соответствующим периодом": "Сравнение основных показателей с соответствующим периодом",
  "Соотношение объема экспорта к периоду проживания": "Соотношение объема экспорта к периоду проживания",
  "В разрезе штатов": "В разрезе штатов",
  "Доля экспорта по странам": "Доля экспорта по странам",
  "Виза для собак": "Виза для собак",
  "Информация о IT VISA": "Информация о IT VISA",
  "Экспорт": "Экспорт",
  "Объем экспорта в разрезе видов деятельности": "Объем экспорта в разрезе видов деятельности",
  "Резиденты с участием иностранного капитала": "Резиденты с участием иностранного капитала",
  "Иностранные организации": "Иностранные организации",
  "Загрузите всю информацию по «Показателям отчета» в Excel": "Загрузите всю информацию по «Показателям отчета» в Excel",
  "Разделение": "Разделение",
  "На сегодняшний день статус": "На сегодняшний день статус",
  "ПОМЕШИВАТЬ": "ПОМЕШИВАТЬ",
  "Название организации": "Название организации",
  "Территория": "Территория",
  "Баланс": "Баланс",
  "Рассчитано": "Рассчитано",
  "Оплаченный": "Оплаченный",
  "Список резидентов": "Список резидентов",
  "Список Ташкентской области": "Список Ташкентской области",
  "Название компании:": "Название компании:",
  "Период:": "Период:",
  "Дата операции": "Дата операции",
  "Содержание операции": "Содержание операции",
  "Дата платежа": "Дата платежа",
  "Оборот в отчете": "Оборот в отчете",
  "Рассчитано на оплату": "Рассчитано на оплату",
  "Задолженность": "Задолженность",
  "Переплата": "Переплата",
  "Город": "Город",
  "Дата регистрации": "Дата регистрации",
  "Статус резидента": "Статус резидента",
  "Резидент": "Резидент",
  "Тип организации": "Тип организации",
  "Государство-основатель": "Государство-основатель",
  "Количество используемых жилых помещений": "Количество используемых жилых помещений",
  "от этого": "от этого",
  "дата платежа": "дата платежа",
  "Добавлено в этот период": "Добавлено в этот период",
  "Количество снятых с регистрации жителей": "Количество снятых с регистрации жителей",
  "Лица, лишенные права проживания в этот период": "Лица, лишенные права проживания в этот период",
  "Номер компании": "Номер компании",
  "Всего сотрудников": "Всего сотрудников",
  "Административный персонал": "Административный персонал",
  "MXTF": "MXTF",
  "Ключевой персонал": "Ключевой персонал",
  "Программисты": "Программисты",
  "Поставщики информационных услуг": "Поставщики информационных услуг",
  "Учителя": "Учителя",
  "Экспорт резидентов": "Экспорт резидентов",
  "Учредители — иностранные резиденты": "Учредители — иностранные резиденты",
  "компания": "компания",
  "Название организации и ИНН": "Название организации и ИНН",
  "Дата резидентства": "Дата резидентства",
  "Территория и город": "Территория и город",
  "Страна регистрации и дата регистрации": "Страна регистрации и дата регистрации",
  "Доля экспорта": "Доля экспорта",
  "Направление экспорта": "Направление экспорта",
  "Графический вид": "Графический вид",
  "Стол": "Стол",
  "В секторе экспортных услуг": "В секторе экспортных услуг",
  "Общий экспорт": "Общий экспорт",
  "ИТ-услуги": "ИТ-услуги",
  "ИТ-образование": "ИТ-образование",
  "Игровая разработка и креатив": "Игровая разработка и креатив",
  "Программные продукты": "Программные продукты",
  "Основатели в разрезе доли экспорта": "Основатели в разрезе доли экспорта",
  "Период резидентства": "Период резидентства",
  "Доход": "Доход",
  "Расширенная информация": "Расширенная информация",
  "Администратор": "Администратор",
  "Примечания": "Примечания",
  "Отчеты": "Отчеты",
  "В графическом виде": "В графическом виде",
  "В табличном виде": "В табличном виде",
  "В разделе территорий / в разделе Республики": "В разделе территорий / в разделе Республики",
  "Жители": "Жители",
  "По территории": "По территории",
  "По активности": "По активности",
  "По словам основателей": "По словам основателей",
  "Развитие ДТ": "Развитие ДТ",
  "Поддерживать": "Поддерживать",
  "Продажа лицензий": "Продажа лицензий",
  "По пригодности для жизни": "По пригодности для жизни",
  "Зарегистрировано": "Зарегистрировано",
  "Исключен из резиденции": "Исключен из резиденции",
  "Число в поперечном сечении территории": "Число в поперечном сечении территории",
  "В разделе учредителей": "В разделе учредителей",
  "В разделе «Тип деятельности»": "В разделе «Тип деятельности»",
  "По категориям сотрудников": "По категориям сотрудников",
  "В зависимости от размера заработной платы": "В зависимости от размера заработной платы",
  "Об иностранных гражданах": "Об иностранных гражданах",
  "Основатель": "Основатель",
  "Количество организаций с долей экспорта более 50 процентов": "Количество организаций с долей экспорта более 50 процентов",
  "По объему экспорта": "По объему дохода",
  "practice_text": "На практике это {amount} млн.сум. Число — {count}.",
  "practice_text2": "На практике это {amount} млн.долл. Число — {count}.",
  "Доля суммы": "Доля суммы",
  "Объем экспорта более 10 миллионов долларов": "Объем общего дохода превышает 100 млрд сумов",
  "Объем экспорта от 1 млн до 10 млн за доллар": "Объем общего дохода от 1 до 50 млрд сумов",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар": "Объем общего дохода от 50 до 100 млрд сумов",
  "Объем экспорта до 100 тыс. долларов": "Объем общего дохода до 1 млрд сумов",
  "Объем экспорта до 100 тыс. долларов2": "Объем экспорта до 50 тысяч долларов",
  "Объем экспорта от 100 тыс. до 1 млн. за доллар2": "Объем экспорта от 50 тысяч до 5 миллионов долларов",
  "Объем экспорта от 1 млн до 10 млн за доллар2": "Объем экспорта от 5 до 10 миллионов долларов",
  "Объем экспорта более 10 миллионов долларов2": "Объем экспорта более 10 миллионов долларов",

  "В разделе стран-экспортеров": "В разделе стран-экспортеров",
  "ТОП-5 стран": "ТОП-5 стран",
  "Сумма территории": "Сумма территории",
  "Общий доход составляет более 100 млрд сумов.": "Общий доход составляет более 100 млрд сумов.",
  "Общий доход от 50 млрд сумов до 100 млрд сумов": "Общий доход от 50 млрд сумов до 100 млрд сумов",
  "Общий доход от 1 млрд сумов до 50 млрд сумов.": "Общий доход от 1 млрд сумов до 50 млрд сумов.",
  "Общий доход до 1 млрд сумов": "Общий доход до 1 млрд сумов",
  "Выберите период для сравнения:": "Выберите период для сравнения:",
  "Ежегодно (ежеквартально)": "Ежегодно (ежеквартально)",
  "В разделе территории": "В разделе территории",
  "Вид деятельности (все)": "Вид деятельности (все)",
  "Территория (вся)": "Территория (вся)",
  "Страна экспорта (все)": "Страна экспорта (все)",
  "Основатели": "Учредители",
  "Страны (все)": "Страны (все)",
  "Все": "Все",
  "Частично": "Частично",
  "Выберите соответствующий индикатор:": "Выберите соответствующий индикатор:",
  "Сумма экспорта": "Сумма экспорта",
  "Те, чей оборот превышает 10 млрд.": "Те, чей оборот превышает 10 млрд.",
  "На 50% больше экспортных поставок": "На 50% больше экспортных поставок",
  "Количество резидентов с иностранным учредителем": "Количество резидентов с иностранным учредителем",
  "Количество программистов": "Количество программистов",
  "Экспорт 100% числа": "Экспорт 100% числа",
  "Количество новых жителей": "Количество новых жителей",
  "Иностранные сотрудники": "Иностранные сотрудники",
  "Количество подписавших соглашение о виртуальном офисе": "Количество подписавших соглашение о виртуальном офисе",
  "Количество регистраций": "Количество регистраций",
  "Очистить": "Очистить",
  "Формирование данных": "Формирование данных",
  "квартал": "квартал",
  "География экспорта": "География экспорта",
  "inp_fild": 'Вы можете написать интересующий вас вопрос',

  "Выберите тип организации": "Выберите тип организации",
  "Выберите страну": "Выберите страну",
  "Выберите день": 'Выберите день',
  "Распределение экспорта": "Распределение экспорта",

  "все резиденты": "все резиденты",
  "Все резиденты": "Все резиденты",
  "Неэкспортеры": "Неэкспортеры",

  "резиденты с иностранными учредителями": "резиденты с иностранными учредителями",
  "резиденты без иностранных учредителей": "резиденты без иностранных учредителей",

  "Название компании": 'Название компании',
  "Учредитель": 'Учредитель',
  "Вид деятельности": 'Вид деятельности',
  "География Экспорта": 'География Экспорта',
  "Кол-во сотрудников": 'Кол-во сотрудников',

  "за весь год": "за весь год",
  "за x-квартал": "за {x}-квартал",
  "by_income": "По доходам",
  "by_indicator": "По показателям",
  "residents_required_to_submit_reports": "Резиденты, обязанные предоставить отчеты",
  "submitted": "Представили",
  "returned_for_editing": "Возвращено на доработку",
  "not_submitted": "Не представили",
  "totalDebtTitle": "Общая задолженность",
  "totalDebtInfo": "резидентов",
  "totalOverpaymentTitle": "Общая переплата",
  "totalOverpaymentInfo": "резидентов",
  "accruedForThePeriodTitle": "Начислено за период",
  "accruedForThePeriodInfo": "резидентов",
  "numberOfResidentsTitle": "Количество резидентов",
  "numberOfResidentsInfo": "Активных компаний",
  "footer_rights": "IT Park Uzbekistan. Все права защищены 2019-2024",
  "1": "Январь",
  "2": "Февраль",
  "3": "Март",
  "4": "Апрель",
  "5": "Май",
  "6": "Июнь",
  "7": "Июль",
  "8": "Август",
  "9": "Сентябрь",
  "10": "Октябрь",
  "11": "Ноябрь",
  "12": "Декабрь",
  "all": "Все",
  "resident": "Резидент",
  "excluded": "Исключен",
  "select": "Выбрать",
  "search_inn": "Поиск ИНН",
  "export_table": "Расширенная-информация",
  "inn": "ИНН",
  "accrued": "Начислено",
  "overdue": "Просрочка",
  "status": "Статус",
  "show": "Показывать",
  "no_data_found": "Данные не найдены",
  "no_data": "Нет данных",
  "financial_summary_on": "Финансовая сводка на",
  "opening_balance": "Сальдо на начало года",
  "accrued_for_period": "Начислено за период",
  "paid_for_period": "Оплачено за период",
  "total_debt": "Итого задолженность",
  "overpayment": "Переплата",
  "current_balance": "Сальдо на сегодня",
  "regions": "Регион",
  "Задолженость": "Задолженность",
  "Оплачено": "Оплачено",

  "report_date": "Дата отчёта",
  "income": "Доход",
  "payable": "Сумма отчислений",
  "days": "дней",
  "balance": "Сальдо",
  "quarter_report": "Отчёт за {quarter} квартал",
  "день": "день",
  "дня": "дня",
  "дней": "дней",
  "table_parameters": "Для формирования таблицы укажите параметры",
  "main": "Основные",
  "activity_types": "Виды деятельности",
  "export_countries1": "Страны экспорта",
  "regions1": "Регионы",
  "countries": "Страны",
  "collapse": "Свернуть",
  "indicators": "Показатели",
  "reset_filters": "Сбросить фильтры",
  "generate_table": "Сформировать таблицу",
  "result": "Развернуть",
  "млрд. сум": "млрд. сум",
  "млн. дол. США": "млн. дол. США",
  "quantity": "Кол-во",
  "percent": "в %",
  "residents_count": "Все резиденты",
  "export_amount": "Сумма экспорта (долл. США)",
  "half_year": "Полгода",
  "yearly": "Годовой",
  "nine_months": "Девять месяцев",
  "Йиллик": "Годовой",
  "Ярим йиллик": "Полгода",
  "1 квартал": "1 квартал",
  "2 квартал": "2 квартал",
  "3 квартал": "3 квартал",
  "4 квартал": "4 квартал",
  "foreign_capital": "Резиденты с участием иностранного капитала",
  "exporting": "Резиденты, осуществляющие экспорт",
  "direction": "Направление",
  "detailed_information": "Подробная информация",
  "date_of_application_of_the_benefit": "Дата применения льготы",
  "Страна-экспортер": "Страна-экспортер",
  "more_th_50_percent": "Больше 50%",
}




